import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=bbd38ebe&scoped=true"
import script from "./TabContent.vue?vue&type=script&lang=ts"
export * from "./TabContent.vue?vue&type=script&lang=ts"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=bbd38ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd38ebe",
  null
  
)

export default component.exports